import { Typography, Tag, Icons } from "@flash-tecnologia/hros-web-ui-v2";
import * as SC from "./modules-usage.styles";
import { Question } from "bff/src/services";
import { getModuleProps } from "../../constants";
import { useEffect } from "react";
import { setPageTracking } from "@/utils";
import { TrackingPages } from "../../types";
import { OptionPicker } from "@/components/core-components/molecules/OptionPicker/option-picker";
import { useTheme } from "styled-components";

interface ModulesUsageProps {
  questions: Question[];
  answers: { [questionId: string]: string };
  onAnswersUsage: (questionId: string, value: string) => void;
}

export const ModulesUsage: React.FC<ModulesUsageProps> = ({
  questions,
  answers,
  onAnswersUsage,
}) => {
  const theme = useTheme();

  useEffect(() => {
    setPageTracking(TrackingPages.SETUP_MODULES_USAGE_WORKFLOW_PAGE);
  }, []);

  return (
    <SC.ResponsiveContainer flexDirection="column" gap="s">
      <Typography.Headline8 color="neutral.20">
        E quando pretende começar a usar os produtos?
      </Typography.Headline8>
      {questions?.map((question) => (
        <OptionPicker
          key={question.id}
          title={question.question}
          options={question.options}
          value={answers[question.id]}
          onChange={(value) => onAnswersUsage(question.id, value)}
          leftSlot={
            <Tag variant="primary" size="small" disabled>
              <Icons
                name={getModuleProps(question.moduleId).icon}
                size={16}
                style={{ background: theme.colors.secondary[95] }}
              />{" "}
              <Typography.Body4 color="secondary.50" weight={600}>
                {getModuleProps(question.moduleId).name}
              </Typography.Body4>
            </Tag>
          }
        />
      ))}
    </SC.ResponsiveContainer>
  );
};
